module.exports = __webpack_public_path__ + "img/olc-poster-image.3655bb77.jpg";